// extracted by mini-css-extract-plugin
export default {"container":"Total-container_w9qP5","removeButton":"Total-removeButton_xTovO"};